<template>
    <div>
        <v-expansion-panels class="mt-6" :value="current_panel">

            <!-- BM: -- GENERAL PHONE SETTINGS -->
            <v-expansion-panel>
                <v-expansion-panel-header>
                    General Settings
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <v-row v-if="phoneSid">
                        <v-col>
                            <v-switch 
                                label="Use custom settings"
                                v-model="phone_numbers.phone_settings.use_custom_settings"
                                messages="Turn this on to override the default settings with the ones below."></v-switch>
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-text-field 
                                label="Forwarding Phone Number" 
                                outlined hide-details 
                                v-model="phone_numbers.phone_settings.forwarding_phone_number"
                                placeholder="+12223334444" />
                        </v-col>
                        <v-col>
                            <v-radio-group
                                row dense hide-details
                                v-model="phone_numbers.phone_settings.caller_id"
                            >
                                <template v-slot:label>
                                    <div>Caller ID:</div>
                                </template>
                                <v-radio
                                    label="Caller #"
                                    value="caller"
                                ></v-radio>
                                <v-radio
                                    label="Called #"
                                    value="called"
                                ></v-radio>
                            </v-radio-group>
                            
                        </v-col>
                    </v-row>
                    <v-row>
                        <v-col>
                            <v-switch label="Forward SMS Messages" hide-details dense v-model="phone_numbers.phone_settings.forward_sms_messages"></v-switch>
                            <v-switch label="Send Call Notification SMS" hide-details dense v-model="phone_numbers.phone_settings.send_call_notification_sms"></v-switch>
                            <v-switch label="Press key to connect" hide-details dense v-model="phone_numbers.phone_settings.press_key_to_connect"></v-switch>
                        </v-col>
                        <v-col>
                            <v-switch label="Whisper lead info" hide-details dense v-model="phone_numbers.phone_settings.whisper_lead_info"></v-switch>
                            <v-switch label="Record" hide-details dense v-model="phone_numbers.phone_settings.record"></v-switch>
                        </v-col>
                    </v-row>
                </v-expansion-panel-content>
            </v-expansion-panel>
        
            <!-- BM: -- ADVANCED PHONE SETTINGS -->
            <v-expansion-panel>
                <v-expansion-panel-header>
                    Advanced Settings
                </v-expansion-panel-header>
                <v-expansion-panel-content>
                    <p>If you prefer that another application handle your incoming calls or texts, you can enter the URLs below. 
                        This will cause all other settings above to have no effect.</p>
                    <v-row>
                        <v-col>
                            <v-text-field label="Redirect Incoming Calls to URL" placeholder="https://" outlined v-model="phone_numbers.phone_settings.voice_redirect_url" />
                        </v-col>
                        <v-col>
                            <v-text-field label="Redirect Incoming SMS to URL" placeholder="https://" outlined v-model="phone_numbers.phone_settings.sms_redirect_url" />
                        </v-col>
                    </v-row>
                    
                </v-expansion-panel-content>
            </v-expansion-panel>
        </v-expansion-panels>
        <v-card-actions>
            <!-- <v-spacer></v-spacer> -->
            <v-btn color="success" class="mt-4" 
                @click="phone_numbers.savePhoneSettings(phoneSid)"
                :loading="phone_numbers.saving_phone_settings"
                :disabled="phone_numbers.saving_phone_settings"
            >
                Save Phone Settings
            </v-btn>
        </v-card-actions>
        <v-overlay :value="phone_numbers.loading_phone_settings" :absolute="true" opacity="1" :color="overlay_color">
            <v-progress-circular
                indeterminate
                size="64"
                color="primary"
            ></v-progress-circular>
        </v-overlay>
    </div>
</template>

<script>
import { usePhoneNumbersStore } from "../stores/phone_numbers"

export default {
    name: 'PhoneSettings',
    props: {
        phoneSid: {
            type: String,
            default: null
        }
    },
    created: function() {
        this.phone_numbers = usePhoneNumbersStore()
    },
    mounted: function() {
        this.phone_numbers.fetchPhoneSettings(this.phoneSid)
        console.log("mounted PhoneSid", this.phoneSid)
    },
    data: () => ({
        phone_numbers: null,
        current_panel: 0
    }),
    computed: {
        overlay_color: function() {
            return this.$vuetify.theme.dark ? "#1E1E1E" : "white" 
        }
    },
    methods: {
        savePhoneSettings: function() {
            this.phone_numbers.savePhoneSettings(phoneSid)
        }
    }
}

</script>